
// src/web/components/compact-input.jsx

import React from 'react'
import ReactDOM from 'react-dom'
import Input from 'react-toolbox/lib/input'
import theme from './themes/compact-input.css'

export default class CompactInput extends React.Component {
  render() {
    const {
      hasFocus,
      ...props
    } = this.props

    return <Input ref="input" {...props} autoFocus={hasFocus} theme={theme} />
  }
}



// WEBPACK FOOTER //
// ./src/web/components/compact-input.jsx